/**
 *
 * @param name
 * @param url
 * @return {string|null}
 */
export default function getParamByName(name, url) {
  const currentUrl = url || window.location.href;
  // eslint-disable-next-line
  const paramName = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${paramName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(currentUrl);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
